var BtnDiscoverPlants = {
    init:function(){
        $(".btn-discover-plants").on("click touchend", function(e){
            e.preventDefault();
            e.stopPropagation();

            if($(".routine-container").length){
                var _yDest = $(".routine-container").offset().top - 60;
            }else{
                var _yDest = $("#recette").offset().top - 60;
            }


            $("html, body").animate({scrollTop:_yDest}, 300);
        })
    }
}

$(window).on("load", function(){
    if($(".akrolab-template .btn-discover-plants").length){
        BtnDiscoverPlants.init();
    }
})